/* eslint-disable */
import { createSlice } from '@reduxjs/toolkit';

const filterSlice = createSlice({
  name: 'filters',
  initialState: {
    dateRange: '7d',     // 24h | 7d | 30d | custom
    customStart: '',
    customEnd: '',
  },
  reducers: {
    setDateRange: (state, action) => {
      state.dateRange = action.payload;
    },
    setCustomDates: (state, action) => {
      state.customStart = action.payload.start;
      state.customEnd = action.payload.end;
      state.dateRange = 'custom';
    },
  },
});

export const { setDateRange, setCustomDates } = filterSlice.actions;
export default filterSlice.reducer;